import { Header, Icon, theme } from '@salecycle/ui-component-library';
import * as React from 'react';
import styled from 'styled-components';

const StyledUnorderedList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  svg {
    margin-right: 10px;
  }

  li {
    margin-bottom: 5px;
  }
`;

export const Form: React.FC = (): JSX.Element => {
  return (
    <div data-testid="CartAbandonment">
      <Header heading="Cart Abandonment Core Rules" />
      <StyledUnorderedList>
        <li>
          <Icon color={theme.vars.newColor.green1} icon="check-circle" /> Customer has left website
        </li>
        <li>
          <Icon color={theme.vars.newColor.green1} icon="check-circle" /> Customer has item(s) in basket
        </li>
      </StyledUnorderedList>
    </div>
  );
};

export default Form;
